import React from 'react';
import PropTypes from 'prop-types';

export default function Columns({ columns, minWidth }) {
  return (
    <div className="bipolar-horizontal-columns" style={{ minWidth }}>
      {columns.map((column, index) => (
        <div
          className="bipolar-horizontal-column"
          data-column-id={column}
          data-column-order={index}
          role="button"
          tabIndex={0}
          aria-label={`Select ${index + 1} out of ${columns.length}`}
        ></div>
      ))}
    </div>
  );
}
Columns.propTypes = {
  columns: PropTypes.array,
  minWidth: PropTypes.number,
};
